import get from 'lodash/get'

import { VENDOR } from '../constants'
import { GtmFacade } from '../modules/gtm.facade'

export class Analytics {
  constructor(gaApp, libs) {
    this.gaApp = gaApp

    this.libs = libs

    this.state = {
      initialized: false,
    }

    this.modules = {
      [VENDOR.GTM]: new GtmFacade(this.libs.gtm, this.gaApp),
    }
  }

  get all() {
    return this.modules
  }

  init(set) {
    Object.keys(set).forEach((key) => get(this.modules, key).init())

    this.state.initialized = true
  }

  /**
   * Сторонние скрипты могут использовать window.dataLayer
   *
   * Проблема в том, что до тех пор, пока gtm не отправит первое событие,
   * window.dataLayer будет равен undefined, и может сломаться работа сторонних скриптов
   */
  initDataLayer() {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      store_country: this.gaApp.i18n.locale.value.country.toUpperCase(),
      store_language: this.gaApp.i18n.locale.value.code.toUpperCase(),
    })
    this.gaApp.eventBus.publish('layer/analitycs/initDataLayer')
  }

  /**
   * Можем инитить аналитику,
   * если она не отключена для конкретного роута
   * или не запущены автотесты
   */
  canStartInitAnalytic() {
    // если у роута отключена аналитика
    const isAnalyticDisabled =
      this.gaApp.services.app.router.isAnalyticDisabled(this.gaApp.route.path)

    return !isAnalyticDisabled && !this.gaApp.automatedTestingConfig
  }

  /**
   * Проверяем права для инициализации всех видов аналитики.
   *
   * Пользователь может отклонить необязательные виды аналитики
   * если включена модалка для принятия кук.
   */
  hasPermissionToInitAll() {
    return true
    // return !this.gaApp.features.get('modalCookiesPermission')
  }

  /**
   * Инициализируем аналитику, только на «разрешенных» роутах и
   * если нам не нужно спрашивать разрешение на использование кук
   * или разрешение у нас уже есть
   */
  initAllWithPermissionsChecks() {
    if (this.gaApp.isWebview) {
      return
    }

    // если можем инитить аналитику
    if (this.canStartInitAnalytic()) {
      // проверяем права и инитим все виды
      if (this.hasPermissionToInitAll()) {
        // if (this.gaApp.features.get('analyticsInitWayV2')) {
        //   this.init(pick(this.modules, [VENDOR.GTM]))

        //   return
        // }

        return this.init(this.all)
      }

      // иначе инитим только обязательную аналитику
      return this.init(this.special)
    }
  }

  /**
   * Инициализируем аналитику, только на «разрешенных» роутах и
   * если ответ на использование кук был установлен
   */
  initAllAfterPermissionsChecks() {
    if (this.gaApp.isWebview) {
      return
    }

    // если можем инитить аналитику
    if (this.canStartInitAnalytic()) {
      // проверяем права и инитим все виды
      if (this.hasPermissionToInitAll()) {
        return this.init(this.all)
      }

      // иначе инитим только обязательную аналитику
      return this.init(this.special)
    }
  }

  get [VENDOR.GTM]() {
    return get(this.modules, VENDOR.GTM)
  }
}
